import { render, staticRenderFns } from "./indexNew.vue?vue&type=template&id=6d7c5101&scoped=true&"
import script from "./indexNew.vue?vue&type=script&lang=js&"
export * from "./indexNew.vue?vue&type=script&lang=js&"
import style0 from "./indexNew.vue?vue&type=style&index=0&id=6d7c5101&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d7c5101",
  null
  
)

export default component.exports